import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {

  constructor() { }
  @HostListener('keypress', ['$event']) OnKeyPress(event: KeyboardEvent) {
    const numberpattern = /[0-9]/;
    if ((!numberpattern.test(event.key) && event.shiftKey) || !numberpattern.test(event.key)) {
      event.preventDefault();
    }
  }
}
